const modules = import.meta.glob<{ default: string }>('./soukalova-*.jpg', { eager: true });

export const soukalImages = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/soukalova-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/soukalova-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);

import fp3d from './fp-3d.jpg';

export const soukalFloorPlans = [
  { image: fp3d, label: "Půdorys – 3D" },
];
